<template>
  <div class="d-flex align-items-center w-100 bg-dark" style="height: calc(100vh - 3.375rem)">
    <BContainer fluid>
      <BRow class="w-100 mx-0">
        <BCol class="text-center" cols="12" sm="10" offset-sm="1" md="6" offset-md="3" xl="4" offset-xl="4">
          <hr style="border-color: #AC8D64;">
          <h1 class="text-center fw-bold font-weight-bold mb-0" style="color: #AC8D64; font-size: 5rem">
            {{ $t("MENU") }}
          </h1>
          <h2 class="text-center fw-bold font-weight-bold mb-0" style="color: #AC8D64; font-size: 3.2rem">
            {{ $t("COMING_SOON") }}
          </h2>
          <hr style="border-color: #AC8D64;">
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>
